exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".QKpkKgMdCMjQrBSEgtwYn{color:#3b9dd9;font-weight:600;margin:0 0 .85714rem}._1NiHW4iXHBffOKOrn5yluJ{margin:0}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"submitConfirmDialog_groupName": "QKpkKgMdCMjQrBSEgtwYn",
	"submitConfirmDialog_message": "_1NiHW4iXHBffOKOrn5yluJ"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.3/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/ProgressReportHFv4/IndividualDevelopmentPlanDetailView/style.postcss
// module id = 2041
// module chunks = 0